import CheckboxV2 from './checkbox-v2';

export default CheckboxV2;
